export default __webpack_public_path__ + "static/media/schedulemeetingarrow.5da3f79d.svg";